import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHookstate } from "@hookstate/core";
import {
    SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { PEOPLE_SERVICES } from "redux/reduxToolkitServices/_commonServices/peopleServices";
import '@progress/kendo-theme-default/dist/all.css';
import {
    ModalTitle,
    ModalButton,
} from "pages/People/PeopleStyled";
import WarningIcon from "assets/svgIcons/PeopleSubSideNav/WarningIcon";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuItem from "@mui/material/MenuItem";
import PeopleAlertModal from "../peopleAlertModal";

const AddPersonModal = React.memo(({groupsData, 
                                    rfidAccessLevelData,
                                    setIsLoading,
                                    addPersonModalOpen,
                                    setAddPersonModalOpen }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [personIdentifier, setPersonIdentifier] = useState("");
    const [groupId, setGroupId] = useState(null);
    const [rfidAccessLevelId, setRfidAccessLevelId] = useState(1);
    const [isFirstNameValid, setIsFirstNameValid] = useState(true);
    const [isLastNameValid, setIsLastNameValid] = useState(true);
    const [shouldSaveAddButtonBeDisabled, setShouldSaveAddButtonBeDisabled] = useState(true);
    const [peopleModalOpen, setPeopleModalOpen] = useState(false);
    const [titlePeopleAlertModal, setTitlePeopleAlertModal] = useState("");
    const [contentPeopleAlertModal, setContentPeopleAlertModal] = useState("");
    const [peopleAlertModalIsMessageOnly, setPeopleAlertModalIsMessageOnly] = useState(false);

    const addPerson = () => {
        if(firstName.length > 1 && lastName.length > 1) {   
            let request = {
                firstName: firstName,
                lastName: lastName,
                identifier: personIdentifier,
                groupId: groupId,
                rfidAccessLevelId: rfidAccessLevelId
            };

            dispatch(PEOPLE_SERVICES.savePersonService(siteId.get(), request)).then((data) => {
                if(data.WarningMessage != null && data.WarningMessage != "") {
                    setTitlePeopleAlertModal(t("Message"));
                    setContentPeopleAlertModal(data.WarningMessage);
                    setPeopleAlertModalIsMessageOnly(true);
                    setPeopleModalOpen(true);
                }
            });

            closeAddPersonModal();
            setIsLoading(true);
        } else {
            setIsFirstNameValid(firstName.length >= 2);
            setIsLastNameValid(lastName.length >= 2);
        }
    }

    const isFirstNameValidation = (e) => {
        setIsFirstNameValid(e.target.value.length >= 2);
    }

    const isLastNameValidation = (e) => {
        setIsLastNameValid(e.target.value.length >= 2);
    }

    const closeAddPersonModal = () => {
        setFirstName("");
        setLastName("");
        setPersonIdentifier("");
        setGroupId(null);
        setRfidAccessLevelId(1);
        setIsFirstNameValid(true);
        setIsLastNameValid(true);
        setAddPersonModalOpen(false);
        setShouldSaveAddButtonBeDisabled(true);
        setPeopleModalOpen(false);
    }

    const openPeopleDiscardChangesModal = () => {
        if(firstName != "" || lastName != "" || personIdentifier != "" || groupId != null) {
            setTitlePeopleAlertModal(t("Confirm_cancel"));
            setContentPeopleAlertModal(t("Are_You_Sure_You_Want_To_Discard_Changes") + "?");
            setPeopleAlertModalIsMessageOnly(false);
            setPeopleModalOpen(true);
        } else {
            closeAddPersonModal();
        }
    }

    const closeAlertModal = () => {
        setPeopleModalOpen(false);
    }

    const addPersonModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: '#ffffff',
        border: '2px solid #ccc',
        boxShadow: 24,
        p: 4,
    };

    const personInput = {
        width: '100%', 
        height: 38, 
        border: 'solid 1px #ccc' 
    }

    return (<>  
                <Modal 
                    open={addPersonModalOpen}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description">
                        <Box sx={addPersonModalStyle}>
                        <ModalTitle>
                                <div>{t("Add_Person")}</div>

                                <div style={{display: 'flex', justifyContent: 'flex-end', cursor: 'pointer'}} onClick={openPeopleDiscardChangesModal}>
                                    <ModalCloseIcon width={18} height={18} color="#fff" />
                                </div>
                            </ModalTitle> 

                            <div style={{ display: 'flex', gap: '20px', marginBottom: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <div>{t("First_Name")}</div>
                                    <input type="text" value={firstName} onBlur={isFirstNameValidation} onChange={(e) => { setFirstName(e.target.value); setShouldSaveAddButtonBeDisabled(false)}} style={personInput} />
                                    {!isFirstNameValid && 
                                        <span style={{color: 'red', fontSize: 10}}>
                                            {(t("First_Name_People_Validation"))}
                                        </span>
                                    }
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div>{t("Last_Name")}</div>
                                    <input type="text" value={lastName} onBlur={isLastNameValidation} onChange={(e) => { setLastName(e.target.value); setShouldSaveAddButtonBeDisabled(false)}} style={personInput} />
                                    {!isLastNameValid && 
                                        <span style={{color: 'red', fontSize: 10}}>
                                            {(t("Last_Name_People_Validation"))}
                                        </span>
                                    }
                                </div>
                                <div style={{ flex: 1 }}>
                                <div>{t("ID2")}</div>
                                    <input type="text" value={personIdentifier} onChange={(e) => { setPersonIdentifier(e.target.value); setShouldSaveAddButtonBeDisabled(false)}} style={personInput} />
                                </div>
                            </div>

                                <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ flex: 1 }}>
                                    <div>{t("Group")}</div>
                                    <FormControl size="small" fullWidth>
                                    <Select
                                        value={groupId}
                                        name="group"
                                        onChange={(e) => { setGroupId(e.target.value); setShouldSaveAddButtonBeDisabled(false)}}
                                        IconComponent={ExpandMoreIcon}
                                        placeholder="Select.."
                                        displayEmpty
                                        inputProps={{ "aria-label": "Without label" }}
                                    >
                                        {groupsData.map((group) => (
                                            <MenuItem key={group.GroupId} value={group.GroupId}>
                                            {group.GroupName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                    <span style={{color: 'black', fontSize: 15}}>
                                        <WarningIcon /> 
                                        {t("People_Group_Warning")}
                                    </span>
                                </div>

                                <div style={{ flex: 1 }}>
                                    <div>{t("Rfid_Access_Level")}</div>
                                    <FormControl size="small" fullWidth>
                                    <Select
                                        value={rfidAccessLevelId}
                                        name="rfidAccessLevel"
                                        onChange={(e) => { setRfidAccessLevelId(e.target.value); setShouldSaveAddButtonBeDisabled(false)}}
                                        IconComponent={ExpandMoreIcon}
                                        displayEmpty
                                        inputProps={{ "aria-label": "Without label" }}
                                    >
                                        {rfidAccessLevelData.map((rfidAccessLevel) => (
                                            <MenuItem key={rfidAccessLevel.Id} value={rfidAccessLevel.Id}>
                                            {rfidAccessLevel.AccessLevel}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <ModalButton>
                                <button 
                                    onClick={openPeopleDiscardChangesModal} 
                                    style={{ marginRight: 10, height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc' }}>
                                        {t("Cancel")}
                                </button>
                                <button 
                                    disabled={shouldSaveAddButtonBeDisabled}
                                    onClick={addPerson}
                                    style={shouldSaveAddButtonBeDisabled ? { height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc', cursor: "not-allowed	"  } : { height: 35, padding: 10, backgroundColor: '#bc9b6a', color: 'white', border: 'solid 1px #ccc' }}>
                                        {t("Save")}
                                </button>
                            </ModalButton>
                        </Box>
                </Modal>
                <PeopleAlertModal
                                 openPeopleAlertModalOpen={peopleModalOpen} 
                                 yesCallbackFunction={() => closeAddPersonModal()}
                                 noCallbackFunction={() => closeAlertModal()}
                                 title={titlePeopleAlertModal}
                                 content={contentPeopleAlertModal} 
                                 loading={false}
                                 isMessageOnly={peopleAlertModalIsMessageOnly} />
        </> 
    );
});

export default AddPersonModal;
